module.exports = __webpack_public_path__ + "static/img/首页banner.82e825b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/新建文件夹/首页banner.png
// module id = Nk0r
// module chunks = 192